module.exports = __webpack_public_path__ + "static/media/trial3_5.0bc88c58.png";